/* eslint-disable */
import React, { useState } from 'react';
import useAuth from 'hooks/useAuth';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from '@mui/material';
import { DateProfileGenerator } from '@fullcalendar/core/internal';
import moment from 'moment-timezone';

export default function History({ data, extraData }) {
    const { role, user } = useAuth();

    function checkRole(roles, compareValue) {
        if (roles === 'ADMIN') {
            return true;
        } else {
            return compareValue === 'ADMIN' ? false : true;
        }
    }

    const timezones = {
        EST: 'America/New_York',
        CST: 'America/Chicago',
        MST: 'America/Denver',
        PST: 'America/Los_Angeles'
    };

    const [selectedTimezone, setSelectedTimezone] = useState('EST');

    // Handle timezone change
    const handleTimezoneChange = (event) => {
        const newTimezone = event.target.value;
        setSelectedTimezone(newTimezone);
    };

    return (
        <>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <strong>Editor Detail</strong>
                            </TableCell>
                            <TableCell>
                                <strong>Changed Field</strong>
                            </TableCell>
                            <TableCell>
                                <strong>Old Value</strong>
                            </TableCell>
                            <TableCell>
                                <strong>New Value</strong>
                            </TableCell>
                            <TableCell>
                                <strong>Date Changed</strong>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.map((entry) =>
                            Object.keys(entry?.editedData)?.map(
                                (category) =>
                                    category !== 'listingStatus' &&
                                    category !== 'completion' &&
                                    category !== 'rooms' &&
                                    category !== 'greenEnergy' &&
                                    category !== 'specialUserAccess' &&
                                    category !== 'attachments' &&
                                    checkRole(role, entry?.editorRole) &&
                                    (Array.isArray(entry?.editedData[category])
                                        ? entry?.editedData[category].map((item, index) =>
                                              Object.keys(item)?.map((field) => (
                                                  <TableRow key={`${entry.id}-${category}-${index}-${field}`}>
                                                      <TableCell>
                                                          <Box>
                                                              <Typography
                                                                  variant="body1"
                                                                  fontWeight="bold"
                                                                  style={{ textTransform: 'capitalize' }}
                                                              >
                                                                  {entry?.editorName}
                                                              </Typography>
                                                              <Typography variant="body2" color="textSecondary">
                                                                  {entry?.editorRole}
                                                              </Typography>
                                                              <Typography variant="body2" color="textSecondary">
                                                                  {entry?.editorEmail}
                                                              </Typography>
                                                          </Box>
                                                      </TableCell>
                                                      <TableCell
                                                          style={{ textTransform: 'capitalize' }}
                                                      >{`${category} > ${field}`}</TableCell>
                                                      <TableCell>
                                                          {Array.isArray(item[field]?.oldValue)
                                                              ? item[field]?.oldValue.length
                                                                  ? item[field]?.oldValue.join(', ')
                                                                  : 'None'
                                                              : item[field]?.oldValue ?? 'None'}
                                                      </TableCell>

                                                      <TableCell>
                                                          {Array.isArray(item[field]?.newValue)
                                                              ? item[field]?.newValue.length
                                                                  ? item[field]?.newValue.join(', ')
                                                                  : 'None'
                                                              : item[field]?.newValue ?? 'None'}
                                                      </TableCell>

                                                      <TableCell>
                                                          {new Date(entry?.updatedAt).toLocaleString('en-US', {
                                                              year: 'numeric',
                                                              month: 'short',
                                                              day: 'numeric',
                                                              hour: '2-digit',
                                                              minute: '2-digit'
                                                          })}
                                                      </TableCell>
                                                  </TableRow>
                                              ))
                                          )
                                        : // Handle objects in editedData
                                          Object.keys(entry?.editedData[category])?.map((field) => (
                                              <TableRow key={`${entry.id}-${category}-${field}`}>
                                                  <TableCell>
                                                      <Box>
                                                          <Typography
                                                              variant="body1"
                                                              fontWeight="bold"
                                                              style={{ textTransform: 'capitalize' }}
                                                          >
                                                              {entry?.editorName}
                                                          </Typography>
                                                          <Typography variant="body2" color="textSecondary">
                                                              {entry?.editorRole}
                                                          </Typography>
                                                          <Typography variant="body2" color="textSecondary">
                                                              {entry?.editorEmail}
                                                          </Typography>
                                                      </Box>
                                                  </TableCell>
                                                  <TableCell style={{ textTransform: 'capitalize' }}>{`${category} > ${field}`}</TableCell>
                                                  <TableCell>
                                                      {Array.isArray(entry?.editedData?.[category]?.[field]?.oldValue)
                                                          ? entry.editedData[category][field].oldValue.length
                                                              ? entry.editedData[category][field].oldValue.join(', ')
                                                              : 'None'
                                                          : entry?.editedData?.[category]?.[field]?.oldValue ?? 'None'}
                                                  </TableCell>

                                                  <TableCell>
                                                      {Array.isArray(entry?.editedData?.[category]?.[field]?.newValue)
                                                          ? entry.editedData[category][field].newValue.length
                                                              ? entry.editedData[category][field].newValue.join(', ')
                                                              : 'None'
                                                          : entry?.editedData?.[category]?.[field]?.newValue ?? 'None'}
                                                  </TableCell>

                                                  <TableCell>
                                                      {entry?.updatedAt
                                                          ? moment(entry?.updatedAt).tz(selectedTimezone).format('MMM D, YYYY, h:mm A')
                                                          : '-'}
                                                  </TableCell>
                                              </TableRow>
                                          )))
                            )
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            {data.length <= 0 && (
                <Box sx={{ width: '100%', minHeight: '5rem', textAlign: 'center', verticalAlign: 'center' }}>
                    <Typography variant="h4" color="textSecondary" sx={{ mt: 4 }}>
                        No data available
                    </Typography>
                </Box>
            )}

            <Box sx={{ mt: 4, p: 2, borderRadius: 2, backgroundColor: 'background.paper', boxShadow: 1 }}>
                <Typography variant="h4" gutterBottom>
                    Additional Information
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="textSecondary">
                            Created By:
                        </Typography>
                        <Typography variant="body1">
                            {extraData?.lister?.firstName} &nbsp;
                            <br />({extraData?.lister?.email})
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" color="textSecondary">
                            Created On:
                        </Typography>
                        <Typography variant="body1">
                            {new Date(extraData?.createdAt).toLocaleString('en-US', {
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                            })}
                        </Typography>
                    </Grid>
                    {extraData?.approvals[extraData?.approvals?.length - 1]?.editor?.roleName && (
                        <>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="subtitle2" color="textSecondary">
                                    Last{' '}
                                    {extraData?.approvals[extraData?.approvals?.length - 1]?.status === 'APPROVED'
                                        ? 'Approved'
                                        : 'Rejected'}{' '}
                                    By:
                                </Typography>
                                <Typography variant="body1">
                                    {extraData?.approvals[extraData?.approvals?.length - 1]?.editor?.roleName} &nbsp;
                                    {extraData?.approvals[extraData?.approvals?.length - 1]?.editor?.firstName} &nbsp;(
                                    {extraData?.approvals[extraData?.approvals?.length - 1]?.editor?.email})
                                </Typography>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <Typography variant="subtitle2" color="textSecondary">
                                    Last{' '}
                                    {extraData?.approvals[extraData?.approvals?.length - 1]?.status === 'APPROVED'
                                        ? 'Approved'
                                        : 'Rejected'}{' '}
                                    On:
                                </Typography>
                                <Typography variant="body1">
                                    {new Date(extraData?.approvals[extraData?.approvals?.length - 1]?.createdAt).toLocaleString('en-US', {
                                        year: 'numeric',
                                        month: 'short',
                                        day: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit'
                                    })}
                                </Typography>
                            </Grid>
                        </>
                    )}
                </Grid>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <FormControl fullWidth sx={{ width: 300 }} size="small">
                    <InputLabel>Timezone</InputLabel>
                    <Select value={selectedTimezone} label="Timezone" onChange={handleTimezoneChange}>
                        {Object.keys(timezones).map((tz) => (
                            <MenuItem key={tz} value={tz}>
                                {tz}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>

            <Box sx={{ mt: 4, p: 2, borderRadius: 2, backgroundColor: 'background.paper', boxShadow: 1 }}>
                <Typography variant="h6" gutterBottom>
                    Approval History
                </Typography>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="approval history table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Approver Name</TableCell>
                                <TableCell>Role</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Date</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {extraData?.approvals
                                ?.slice()
                                .reverse()
                                ?.map((row) => (
                                    <TableRow key={row.id}>
                                        <TableCell>{`${row?.editor?.firstName || ''} ${row?.editor?.lastName || ''}`}</TableCell>
                                        <TableCell>{row?.editor?.roleName}</TableCell>
                                        <TableCell>{row?.editor?.email}</TableCell>
                                        <TableCell>{row?.status}</TableCell>
                                        <TableCell>
                                            {row?.createdAt
                                                ? moment(row?.createdAt).tz(selectedTimezone).format('MMM D, YYYY, h:mm A')
                                                : '-'}
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                {extraData?.approvals.length <= 0 && (
                    <Box sx={{ width: '100%', minHeight: '5rem', textAlign: 'center', verticalAlign: 'center' }}>
                        <Typography variant="h4" color="textSecondary" sx={{ mt: 4 }}>
                            No data available
                        </Typography>
                    </Box>
                )}
            </Box>

            <Box sx={{ mt: 4, p: 2, borderRadius: 2, backgroundColor: 'background.paper', boxShadow: 1 }}>
                <Typography variant="h3" gutterBottom>
                    Status History
                </Typography>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="Status history table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Manager Name</TableCell>
                                <TableCell>Role</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Date</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {extraData?.statusHistory?.map((row) => (
                                <TableRow key={row.id}>
                                    <TableCell>{`${row?.editor?.firstName || ''} ${row?.editor?.lastName || ''}`}</TableCell>
                                    <TableCell>{row?.editor?.roleName}</TableCell>
                                    <TableCell>{row?.editor?.email}</TableCell>
                                    <TableCell>{row?.status === 'DEFAULT' ? 'RE_ACTIVE' : row?.status}</TableCell>
                                    <TableCell>
                                        {row?.createdAt ? moment(row?.createdAt).tz(selectedTimezone).format('MMM D, YYYY, h:mm A') : '-'}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                {extraData?.statusHistory?.length <= 0 && (
                    <Box sx={{ width: '100%', minHeight: '5rem', textAlign: 'center', verticalAlign: 'center' }}>
                        <Typography variant="h4" color="textSecondary" sx={{ mt: 4 }}>
                            No data available
                        </Typography>
                    </Box>
                )}
            </Box>
        </>
    );
}
